import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { CurrencyField, DateField, TextField } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { formatDate, formatDateIgnoreTimezone, isNotBlank, parseDate } from '@roc/feature-utils';

interface UwHudFormContentProps {
  open: boolean;
}

export const UwHudEditModal = observer(({ open }: UwHudFormContentProps) => {
  const { docReviewStoreV2 } = useStore();
  const { uwHudFormStore } = docReviewStoreV2;

  useEffect(() => {
    if (open) uwHudFormStore.load(docReviewStoreV2.docReviewData);
  }, [open]);

  const handleChange = (field: string, value: any) => {
    uwHudFormStore.onFieldChange(field, value);
  };

  const f = uwHudFormStore.form.fields;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CurrencyField
          label="Acquisition Price"
          value={f.salesPrice.value}
          onChange={(_name, value) => handleChange('salesPrice', value)}
          name="salesPrice"
          testId="salesPrice"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.salesPrice.error)}
          errorText={f.salesPrice.error}
        />
      </Grid>
      <Grid item xs={12}>
        <DateField
          label="Acquisition Date"
          value={
            f.settlementDate.value ? parseDate(f.settlementDate.value) : null
          }
          onChange={value =>
            handleChange(
              'settlementDate',
              value ? formatDate(value, 'yyyy-MM-dd') : value
            )
          }
          error={isNotBlank(f.settlementDate.error)}
          errorText={f.settlementDate.error}
          format="MM/dd/yyyy"
          testId="settlementDate"
          inputVariant="outlined"
          fullWidth
          standaloneLabel
          required
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Seller Name"
          value={f.sellerName.value}
          onChange={e => handleChange('sellerName', e.target.value)}
          name="sellerName"
          testId="sellerName"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.sellerName.error)}
          helperText={f.sellerName.error}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Wholesaler Name"
          value={f.wholesalerName.value}
          onChange={e => handleChange('wholesalerName', e.target.value)}
          name="wholesalerName"
          testId="wholesalerName"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.wholesalerName.error)}
          helperText={f.wholesalerName.error}
        />
      </Grid>
      <Grid item xs={12}>
        <CurrencyField
          label="Wholesale Fee"
          value={f.wholesaleFee.value}
          onChange={(_name, value) => handleChange('wholesaleFee', value)}
          name="wholesaleFee"
          testId="wholesaleFee"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.wholesaleFee.error)}
          errorText={f.wholesaleFee.error}
        />
      </Grid>
      <Grid item xs={12}>
        <CurrencyField
          label="Seller Credit"
          value={f.sellerCredit.value}
          onChange={(_name, value) => handleChange('sellerCredit', value)}
          name="sellerCredit"
          testId="sellerCredit"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.sellerCredit.error)}
          errorText={f.sellerCredit.error}
        />
      </Grid>
      <Grid item xs={12}>
        <CurrencyField
          label="Payoff Amount"
          value={f.payoffAmount.value}
          onChange={(_name, value) => handleChange('payoffAmount', value)}
          name="payoffAmount"
          testId="payoffAmount"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.payoffAmount.error)}
          errorText={f.payoffAmount.error}
        />
      </Grid>
    </Grid>
  );
});
